/**
 * @fileoverview Module for `src/letter-kits/LetterKitIcon.js`.
 */

import PropTypes from 'prop-types';

import '../scss/letter-kits/_letter-kit-icon.scss';

/**
 * Icon card used in letter kit explainer sections.
 *
 * @param {Object} params
 * @returns {JSX.Element} Letter kit icon figure.
 */
function LetterKitIcon({ alt, caption, src }) {
  return (
    <div className='col-md-4 letter-kit-icon'>
      <figure className='figure w-100'>
        <div>
          <img alt={ alt } className='figure-img' src={ src } />
        </div>
        <figcaption className='figure-caption'>
          { caption }
        </figcaption>
      </figure>
    </div>
  );
}

LetterKitIcon.propTypes = {
  alt: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

export default LetterKitIcon;
